import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
const originalPush = VueRouter.prototype.push;
const flag = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
const postId = localStorage.getItem("iuPost") * 1;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);
//console.log(flag);
const routes = [
  {
    path: "",
    redirect: "/dologin",
  },

  {
    path: "/dologin",
    name: "dologin",
    component: () => import("../views/doLogin.vue"),
    meta: {
      title: "登录",
    },
  },

  {
    path: "/Home",
    name: "Home",
    component: () => import("../views/Home.vue"),
    children: [
      {
        path: "",
        redirect: "/Home/userList",
      },
      {
        path: "userList",
        name: "userList",
        component: () => import("../views/user/userList"),
      },
       {
        path: "salary",
        name: "salary",
        component: () => import("../views/salary/salary"),
      },
         {
        path: "salaryTwo",
        name: "salaryTwo",
        component: () => import("../views/salary/salaryTwo"),
      },
         {
        path: "salaryThree",
        name: "salaryThree",
        component: () => import("../views/salary/salaryThree"),
      },
         {
        path: "salaryFour",
        name: "salaryFour",
        component: () => import("../views/salary/salaryFour"),
      },
       {
        path: "dingTalkReceiptRecord",
        name: "dingTalkReceiptRecord",
        component: () => import("../views/dingTalkReceiptRecord/dingTalkReceiptRecord"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
